/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo } from "react";
import { Control, useController } from "react-hook-form";
import { Textarea } from "tvs-unified-lib";

export interface TextareaFieldProps {
  label?: string;
  name: string;
  control: Control<any>;
  isRequired?: boolean;
  placeholder?: string;
  characterLimit?: number;
  disabled?: boolean;
}

export const TextareaField = memo(
  ({
    label,
    name,
    control,
    isRequired = false,
    placeholder,
    characterLimit,
    disabled,
  }: TextareaFieldProps) => {
    const {
      field: { onChange, value },
      fieldState: { error },
    } = useController({ name, control });

    return (
      <Textarea
        name={name}
        placeholder={placeholder}
        value={value ?? ""}
        formLabel={label}
        isRequired={isRequired}
        characterLimit={characterLimit ?? undefined}
        onInputChange={(e) => {
          onChange?.(e);
        }}
        hasError={!!error}
        errorMessage={error?.message}
        disabled={disabled}
      />
    );
  }
);

export default TextareaField;
